module.exports = __webpack_public_path__ + "static/img/video.39e31cd1.png";